import { useState } from "react";
import { Grid, Typography, Box, Card, CardContent, Dialog, Fade, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Header from "../utils/Header";
import Footer from "../utils/Footer";
import ImageWithOverlay from "../utils/ImageWithOverlay";
import AboutUs from "../../public/media/agristack/as_bg.jpg";
import rain from "../../public/media/agristack/rain.jpg";
import temp from "../../public/media/agristack/temp.jpg";
import blue from "../../public/media/agristack/blue.jpg";

export default function CompleteCareer() {
  const [selectedImg, setSelectedImg] = useState(null);

  const cardsData = [
    {
      img: rain,
      alt: "Rainfall",
      title: "Annual Rainfall Over Pakistan (mm/year)",
    },
    {
      img: temp,
      alt: "MODIS",
      title: "Annual Max Temperature Over Pakistan (C)",
    },
    {
      img: blue,
      alt: "Sentinel 3",
      title: "SENTINEL 3 (300m Resolution)",
    },
  ];

  return (
    <>
      <Header />
      <ImageWithOverlay
        image={AboutUs}
        height="400px"
        title="Agri Stack"
        titlePartOne="Agri Stack"
        titlePartTwo=""
      />
      <Box className="container" sx={{ mt: 5, mb: 5 }}>
        <Grid container spacing={4} alignItems="stretch">
          {cardsData.map((card, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                elevation={0}
                onClick={() => setSelectedImg(card)}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  borderRadius: 2,
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.12)",
                    "& img": {
                      transform: "scale(1.05)",
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: 380,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    borderRadius: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={card.img}
                    alt={card.alt}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      transition: "transform 0.4s ease",
                    }}
                  />
                </Box>
                <CardContent sx={{ textAlign: "center", px: 1, py: 2 }}>
                  <Typography variant="body1" fontWeight="bold">
                    {card.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Zoom Lightbox Modal */}
      {/* Zoom Lightbox Modal */}
<Dialog
  open={Boolean(selectedImg)}
  onClose={() => setSelectedImg(null)}
  maxWidth="lg"
  TransitionComponent={Fade}
  transitionDuration={300}
  PaperProps={{
    sx: {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      boxShadow: "none",
      overflow: "visible", // Prevents button clipping
      position: "relative",
      p: { xs: 2, sm: 3 },
    },
  }}
>
  {selectedImg && (
    <Box sx={{ position: "relative", textAlign: "center" }}>
      {/* Close Button with high zIndex */}
      <IconButton
        onClick={() => setSelectedImg(null)}
        sx={{
          position: "absolute",
          top: -12,
          right: -12,
          zIndex: 10, // Keeps button floating above the image layer
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          "&:hover": { 
            backgroundColor: "rgb(255, 255, 255)",
            borderColor: "#7a7a7a",
            color: "#000000"
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        component="img"
        src={selectedImg.img}
        alt={selectedImg.alt}
        sx={{
          maxHeight: "80vh",
          maxWidth: "100%",
          objectFit: "contain",
          borderRadius: 1,
          display: "block",
          margin: "0 auto",
          animation: "zoomIn 0.3s ease-in-out",
          "@keyframes zoomIn": {
            "0%": { transform: "scale(0.7)", opacity: 0 },
            "100%": { transform: "scale(1)", opacity: 1 },
          },
        }}
      />

      <Typography
        variant="h6"
        sx={{ color: "#fff", mt: 2, fontWeight: "500" }}
      >
        {selectedImg.title}
      </Typography>
    </Box>
  )}
</Dialog>

      <Footer />
    </>
  );
}